import { AccessLevelHeE, AccessLevelUserManagementE, AccessLevelUserManagementHeE, ClientStatusE, DeliveryOrderStatusE, FileTypeHebrewE, UserStatusHeE, VideoGuideStatusE } from './../../models/enums';
import {
    AccessLevelE,
    CampaignStatusE,
    ClientSubtypeE,
    ClientTypeE,
    LangE,
    ProjectStatusE,
    FileTypeE,
    SupportMessageStatusE,
    AdvertiserAndBrandStatusE,
    MailRecipientE,
    EmailStatusE,
    LeadStatusE,
    FTPServerE,
    UserStatusE,
    ProjectFileStatusE,
    NotificationTypeE,
} from "../../models/enums";
import { SelectOptionT } from "../../models/models";
import { countries } from "./countries";

const getSelectOptionsFromEnum = (e: any) => {
    return Object.entries(e).map(type => ({ value: +type[0], label: type[1] as string })).filter(({ value }) => !isNaN(value));
};

export const selectValue = (selectOptions: SelectOptionT[], value: any) => {
    return selectOptions?.find(({ value: listValue }) => listValue === value);
};

export const clientTypesSO = getSelectOptionsFromEnum(ClientTypeE);
export const notificationTypeSO = getSelectOptionsFromEnum(NotificationTypeE);
export const videoGuideStatusSO = getSelectOptionsFromEnum(VideoGuideStatusE);
export const clientSubTypesSO = getSelectOptionsFromEnum(ClientSubtypeE);
export const campaignStatusSO = getSelectOptionsFromEnum(CampaignStatusE);
export const clientStatusSO = getSelectOptionsFromEnum(ClientStatusE);
export const projectStatusSO = getSelectOptionsFromEnum(ProjectStatusE);
export const accessLevelSO = getSelectOptionsFromEnum(AccessLevelE);
export const accessLevelHeSO = getSelectOptionsFromEnum(AccessLevelHeE);
export const accessLevelUserManagementSO = getSelectOptionsFromEnum(AccessLevelUserManagementE);
export const accessLevelUserManagementHeSO = getSelectOptionsFromEnum(AccessLevelUserManagementHeE);
const unsortedFileTypeSO = getSelectOptionsFromEnum(FileTypeE);
const unsortedFileTypeHebrewSO = getSelectOptionsFromEnum(FileTypeHebrewE);
export const fileTypeSO = [unsortedFileTypeSO[0], unsortedFileTypeSO[1], unsortedFileTypeSO[2]];
export const fileTypeHebrewSO = [unsortedFileTypeHebrewSO[0], unsortedFileTypeHebrewSO[1], unsortedFileTypeHebrewSO[2]];
export const supportMessageStatusSO = getSelectOptionsFromEnum(SupportMessageStatusE);
export const advertiserStatusSO = getSelectOptionsFromEnum(AdvertiserAndBrandStatusE);
export const emailStatusSO = getSelectOptionsFromEnum(EmailStatusE);
export const mailRecipientSO = getSelectOptionsFromEnum(MailRecipientE);
export const leadStatusSO = getSelectOptionsFromEnum(LeadStatusE);
export const FTPServerSO = getSelectOptionsFromEnum(FTPServerE);
export const userStatusSO = getSelectOptionsFromEnum(UserStatusE);
export const userStatusHeSO = getSelectOptionsFromEnum(UserStatusHeE);
export const projectFileStatusSO = getSelectOptionsFromEnum(ProjectFileStatusE);
export const deliveryStatusSO = getSelectOptionsFromEnum(DeliveryOrderStatusE);
export const countrySO = countries.map(country => ({ value: country.code, label: country.name }));
export const langSO = [{ value: LangE.EN, label: 'English' }, { value: LangE.HE, label: 'Hebrew' }];
export const cultureSO = [{ value: 'en-US', label: 'English' }, { value: 'he-IL', label: 'Hebrew' }];
export const countryShortSO = [{ value: 'en-US', label: 'United States' }, { value: 'he-IL', label: 'Israel' }, { value: 'ua', label: 'Ukraine' }];
export const directionSO = [{ value: 0, label: 'LTR' }, { value: 1, label: 'RTL' }];
export const paymentStatusesSO = [
    { value: 0, label: 'To be charged' },
    { value: 1, label: 'Proforma invoice' },
    { value: 2, label: 'Billed' },
    { value: 3, label: 'No charge' },
];
export const paymentMethodsSO = [
    { value: 0, label: 'Credit card' },
    { value: 1, label: 'Wire transfer' },
    { value: 2, label: 'Check' },
];
export const paymentTermsSO = [
    { value: 0, label: 'Current' },
    { value: 1, label: 'Current +30' },
    { value: 2, label: 'Current +60' },
    { value: 3, label: 'Current +90' },
    { value: 4, label: 'Current +120' },
];
export const clientCurrencySO = [
    { value: 0, label: 'NIS' },
    { value: 1, label: 'USD' },
    { value: 2, label: 'EUR' },
];

/**
 * returns [{ value: 0, label: 'Advertisers'},{ value: 1, label: 'Broadcasters'}] from string like "Advertisers,Broadcasters"
*/
export const getSelectOptionsFromRecipients = (recipients: string | undefined) => {
    if (!recipients) return undefined;
    const values = recipients.split(',').map(value => value.trim());

    const foundKeys = Object.keys(MailRecipientE).filter(key => (values.some((v) => v === key)))

    const res = foundKeys.map(key => ({ value: MailRecipientE[key as any], label: key }));

    return res;
};